// ../hooks/DataFetching/useFetchPosts.js
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useFetchPosts = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently } = useAuth0();
    const apiUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const populatePostsData = async () => {
            try {
                const token = await getAccessTokenSilently({
                    authorizationParams: {
                        audience: process.env.REACT_APP_API_AUDIENCE,
                    },
                });
                const response = await fetch(`${apiUrl}/api/posts`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setPosts(data);
                    setLoading(false);
                } else {
                    console.error('Failed to fetch posts:', response.statusText);
                }
            } catch (error) {
                console.error('Error fetching posts:', error.message);
            }
        };
        populatePostsData();
    }, [getAccessTokenSilently]);

    return { posts, loading };
};
